import { GET_COMPANY_INFO } from './actionTypes';

export const initialState = {};

// eslint-disable-next-line @typescript-eslint/default-param-last
const company = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_COMPANY_INFO.SUCCESS:
      return payload;
    default:
      return state;
  }
};

export default company;
